(function($) {
	// Get Window Width and Height
	var windowWidth = $(window).outerWidth();
	var windowHeight = $(window).height();

	var didScroll;
	var lastScrollTop = 0;
	var delta = 5;
	var navbarHeight = $('#site-header').outerHeight();

	if( windowWidth <= 1023 ) {
		console.log("WWHWH");
		$( '#pageWrp' ).css('padding-top', navbarHeight)
	}

	$(window).scroll(function(event){
	    didScroll = true;
	});

	setInterval(function() {
	    if (didScroll) {
	        hasScrolled();
	        didScroll = false;
	    }
	}, 250);

	function hasScrolled() {
	    var st = $(this).scrollTop();
	    if (st==0) {
			$('body').removeClass('scrolled');
		}
	    // Make sure they scroll more than delta
	    if(Math.abs(lastScrollTop - st) <= delta)
	        return;

	    // If they scrolled down and are past the navbar, add class .nav-up.
	    // This is necessary so you never see what is "behind" the navbar.
	    if (st > lastScrollTop && st > navbarHeight){
	        // Scroll Down
	        $('body').addClass('scrolled');
	    } else {
	        // Scroll Up
	        if(st + $(window).height() < $(document).height()) {
	            $('body').removeClass('scrolled');
	        }
	    }
	    lastScrollTop = st;
	}

	/* Document ready functions */
	$(document).ready(function (){

		// Toggle mobile menu
    $('.mobile-menu-button').on('click',function(){
      $('body').toggleClass('navOpen');
			$(".header-search").removeClass("visible");
    });

		// Show and hide mobile sub menu
		function close_menu_section() {
        $('.menu-item-has-children a').removeClass('active');
        $('.menu-item-has-children a').next().slideUp(300).removeClass('open');
    }
    $('.menu-item-has-children a').not('.sub-menu a').click(function(e) {
        if($(this).hasClass('active')) {
            close_menu_section();
        }else {
            $('.menu-item-has-children a').next().hide().removeClass('open');
            // Add active class to section title
            $(this).addClass('active');
            // Open up the hidden content panel
            $(this).next().slideDown(300).addClass('open');
        }
        e.preventDefault();
    });

		// Show and hide header search
		$(".header-search-icon .fa-search").on("click", function() {
			$('body').removeClass('navOpen');
			if($(".header-search").hasClass("visible")) {
				$(".header-search").removeClass("visible");
			} else {
				$(".header-search").addClass("visible");
			}
		});

	});

	$(window).resize(function () {

		// Get Window Width and Height on resize
		windowWidth = $(window).outerWidth();
		windowHeight = $(window).height();


	});

})(jQuery);
